// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"447":"d4e94c8c","486":"60c5cc2c"}[chunkId] + ".chunk.css";
};